module.exports = require("bluebird");


//////////////////
// WEBPACK FOOTER
// external "bluebird"
// module id = 14
// module chunks = 0